import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { consumptionDataColumns } from '@/features/tmaisUsers/constants/consumptionDataColumns.constant'
import { useTmaisUserConsumptions } from '@/features/tmaisUsers/hooks/useTmaisUserConsumptions'
import { ConsumptionDataTransformer } from '@/features/tmaisUsers/services/consumptionDataTransformer'
import { ConsumptionData, ConsumptionTableItem } from '@/features/tmaisUsers/types/tmaisUserConsumptions.type'

interface ConsumptionDataTabProps {
  userId: string
}

export default function ConsumptionDataTab({ userId }: ConsumptionDataTabProps) {
  const { filterParams, setFilterParams } = useFilterParams()

  const {
    data: consumptions,
    meta,
    isPending,
  } = useTmaisUserConsumptions<ConsumptionTableItem[]>({
    userId,
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<ConsumptionData[], ConsumptionTableItem[]>({
      transformer: ConsumptionDataTransformer.tableTransformer(),
    }),
  })

  return (
    <Table
      className="max-h-[calc(100vh-192px)]"
      columns={consumptionDataColumns}
      rows={consumptions || []}
      rowEmptyValue="--"
      isLoadingData={isPending}
      page={filterParams.page || 1}
      totalPages={meta?.total_pages || 1}
      totalCount={meta?.total}
      hasPagination
      setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
    />
  )
}
